<template>
  <div>
    <b-input
      v-model="flaw.text"
      :error-messages="getErrorMessages(v$.text)"
      label="Назва"
      placeholder="Введіть значення"
      @blur="v$.text.$touch()">
    </b-input>
    <b-textarea
      v-model="flaw.factorFlaw"
      :error-messages="getErrorMessages(v$.factorFlaw)"
      label="Опис"
      placeholder="Введіть значення"
      @blur="v$.factorFlaw.$touch()">
    </b-textarea>
  </div>
</template>

<script lang="ts">
import { PropType, reactive } from 'vue'
import { Dialog } from '@/dialog'
import { required } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import { getErrorMessages } from 'best-modules/utils'
import { AuditFlaw } from '@/utils/types/audit'
import { BTextarea } from 'best-modules/components'
import { auditFlawCreate, auditFlawUpdate } from '@/requests/audit'

export default {
  name: 'AuditFlaw',
  components: { BTextarea },
  props: {
    dialog: {
      type: Object as PropType<Dialog>,
      required: true,
    },
  },
  methods: { getErrorMessages },
  setup(props) {
    const flaw = reactive<AuditFlaw>({
      auditId: props.dialog.dialogData.auditId,
      text: null,
      factorFlaw: null,
    } as AuditFlaw)
    if (props.dialog.action === 'update') {
      Object.assign(flaw, props.dialog.dialogData.flaw)
    }
    const rules = {
      text: { required: required },
      factorFlaw: { required: required },
    }
    const v$ = useVuelidate(rules, flaw)

    const submit = () => {
      if (props.dialog.action === 'create') {
        return auditFlawCreate(flaw).then(res => {
          return res
        })
      }
      if (props.dialog.action === 'update') {
        return auditFlawUpdate(flaw.id, flaw).then(res => {
          return res
        })
      }
    }

    return { flaw, v$, submit }
  },
}
</script>

<style lang="scss" scoped></style>
